import { useState } from "nuxt/app";
import { login, getLoginUrl } from "../utils/LoginUtils.js";
import { logout, getLogoutUrl } from "../utils/LogoutUtils.js";
import { initSso } from "../utils/SsoUtils.js";
function normalizeGender(gender) {
  switch (true) {
    case (gender === "m" || gender === "male"):
      return "M";
    case (gender === "f" || gender === "female"):
      return "F";
    default:
      return "U";
  }
}
export default function usePip() {
  const userinfo = useState("userinfo");
  const isAuth = useState("isAuth", () => false);
  const isPipDisabled = useState("isPipDisabled");
  function setIsAuth(value) {
    isAuth.value = value;
  }
  function setUserinfo(value) {
    userinfo.value = value;
  }
  return {
    initSso,
    login,
    getLoginUrl,
    logout,
    getLogoutUrl,
    userinfo,
    isAuth,
    isPipDisabled,
    normalizeGender,
    setIsAuth,
    setUserinfo
  };
}
